import React, { useEffect, Fragment } from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';
import { withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import Icon from '../Icon';
import Loader from '../common/Loader';
import InvitePatientConsent from './InvitePatientConsent';
import PaymentGate from './PaymentGate';
import VisitHeader from '../VirtualVideoRoom/Components/VisitHeader';
import { COMPLETED_APPOINTMENT_STATUSES } from '../../constants/index';
import * as roomInvitationInfo from '../../redux/healthboard/requests/room-invitation-info-req';
import * as connectionRoomJoin from '../../redux/healthboard/requests/connection-room-join-req';
import {
  selectShouldSignConsent,
  selectRoomInvitationJoinError,
  selectRoomInvitationJoinStatus,
  selectRoomInvitationJoinPending,
  selectRoomInvitationJoinRoomName,
  selectRoomInvitationJoinSucceed,
  selectConnectionRoomJoinPending,
  selectConnectionRoomJoinError,
  selectRoomInvitationInfoPending,
  selectRoomInvitationInfoError,
  selectRoomInvitationInfoSucceed,
  selectRoomInvitationInfoPaymentRequired,
  selectRoomInvitationInfoPatientName,
  selectRoomInvitationInfoAppointmentId,
  selectRoomInvitationInfoCopay,
  selectRoomInvitationInfoVisitTypeName,
} from '../../redux/healthboard/selectors';

import styles from './styles.styl';
import { usePageView } from '../../hocs/usePageView';
import MetaHelmet from '../AppHelmet/MetaHelmet';

function VirtualRoom({ connectionRoom, location }) {
  const dispatch = useDispatch();

  const errorVirtualRoom = useSelector(selectRoomInvitationJoinError);
  const errorConnectionRoom = useSelector(selectConnectionRoomJoinError);
  const errorInvitationInfo = useSelector(selectRoomInvitationInfoError);
  const joinName = useSelector(selectRoomInvitationJoinRoomName);
  const infoName = useSelector(selectRoomInvitationInfoPatientName);
  const name = joinName || infoName;
  const status = useSelector(selectRoomInvitationJoinStatus);
  const pendingVirtualRoom = useSelector(selectRoomInvitationJoinPending);
  const pendingConnectionRoom = useSelector(selectConnectionRoomJoinPending);
  const pendingInvitationInfo = useSelector(selectRoomInvitationInfoPending);
  const shouldSignConsent = useSelector(selectShouldSignConsent);
  const invitationInfoSucceed = useSelector(selectRoomInvitationInfoSucceed);
  const isRequiredPayment = useSelector(
    selectRoomInvitationInfoPaymentRequired,
  );
  const appointmentId = useSelector(selectRoomInvitationInfoAppointmentId);
  const copay = useSelector(selectRoomInvitationInfoCopay);
  const visitTypeName = useSelector(selectRoomInvitationInfoVisitTypeName);
  const joinSucceed = useSelector(selectRoomInvitationJoinSucceed);

  const code = get(window.location, 'hash', '').slice(1);
  const combinedPending =
    pendingVirtualRoom || pendingConnectionRoom || pendingInvitationInfo;
  const combinedError =
    errorVirtualRoom || errorConnectionRoom || errorInvitationInfo;

  usePageView('Virtual Room | Invite');
  useEffect(() => {
    if (connectionRoom) {
      dispatch(connectionRoomJoin.actions.send({ inviteCode: code }));
    } else {
      dispatch(roomInvitationInfo.actions.send({ inviteCode: code }));
    }
  }, [connectionRoom, location]);

  const completed = COMPLETED_APPOINTMENT_STATUSES.includes(status);

  const showPaymentGate =
    !connectionRoom &&
    !!invitationInfoSucceed &&
    isRequiredPayment &&
    !pendingVirtualRoom &&
    !joinSucceed;

  return (
    <div className={styles.wrapper}>
      <MetaHelmet title="pages.title.virtualRoom" />

      <VisitHeader
        full
        noInfo
        noDescription
        roomDetails={{ name, connectionRoom, visitType: visitTypeName }}
      />
      <div className={styles.content}>
        {combinedPending && <Loader />}
        {!combinedPending && showPaymentGate && (
          <PaymentGate appointmentId={appointmentId} copay={copay} />
        )}
        {shouldSignConsent && <InvitePatientConsent code={code} />}
        {!combinedPending && (combinedError || completed) && (
          <Fragment>
            <Icon name="video-completed" size={100} className={styles.icon} />
            <div className={styles.text}>
              {completed ? (
                <FormattedMessage id="virtualVisit.error.visitCompleted" />
              ) : (
                <FormattedMessage
                  id={`virtualVisit.error.${
                    connectionRoom ? 'callCompleted' : 'invalidLink'
                  }`}
                />
              )}
            </div>
          </Fragment>
        )}
        {!combinedPending && !combinedError && connectionRoom && (
          <Fragment>
            <Icon name="video-completed" size={100} className={styles.icon} />
            <div className={styles.text}>
              <FormattedMessage id="virtualVisit.error.callCompleted" />
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
}

VirtualRoom.propTypes = {
  location: PropTypes.object,
  connectionRoom: PropTypes.bool,
};

export default withRouter(VirtualRoom);



// WEBPACK FOOTER //
// ./src/components/VirtualRoom/index.jsx